import { useEffect, useState } from 'react';
import { useMatchMedia } from 'App/Header/useMatchMedia';
import {
	areSiblings,
	calcLogoOverlapBreakpoint,
	computeImageDimensions,
	ImageDimensions,
} from 'App/Header/util';

export const useLogoCompressionBreakpoint = (logoUrl: string, searchBarWidth = 360) => {
	const [overlapBreakpoint, setOverlapBreakpoint] = useState<number | null>(null);
	const [compressedDims, setCompressedDims] = useState<ImageDimensions | null>(null);
	const isBelowBreakpoint = useMatchMedia(`(max-width: ${overlapBreakpoint}px)`);

	useEffect(() => {
		const searchBarElement = document.getElementById('search-module');
		const logoElement = document.getElementById('workspace-logo-link');
		if (!areSiblings(searchBarElement, logoElement)) {
			return;
		}
		const initializeLogoBreakpoint = async () => {
			const breakpoint = await calcLogoOverlapBreakpoint(logoUrl, searchBarWidth);
			setOverlapBreakpoint(breakpoint);
		};
		initializeLogoBreakpoint();
	}, [logoUrl, searchBarWidth]);

	useEffect(() => {
		if (!overlapBreakpoint) {
			return;
		}
		async function shouldCompress() {
			if (isBelowBreakpoint) {
				const compressed = await computeImageDimensions(logoUrl);
				setCompressedDims(compressed);
			} else {
				setCompressedDims(null);
			}
		}
		shouldCompress();
	}, [isBelowBreakpoint, logoUrl, overlapBreakpoint]);

	return { isBelowBreakpoint, compressedDims };
};
